import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["reportingWidgetId", "config"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { chartColorPallet as DEFAULT_COLORS } from '@/config/colorPallets/universalDesignSystem';
import { hasAnySelectionData } from '../../utils/selections';
import useSelections from '@/components/widget/misc/useSelections';
import useSelectionLabels from '@/components/widget/misc/useSelectionLabels';
import useSelectionLegends from '@/components/widget/misc/useSelectionLegends';
import useSubscribeWidgetResults from '../hooks/useSubscribeWidgetResults';
import useData from './useData';
import useChartActions from '../internal/useChartActions';
import { useLineStyles } from '../internal/LineChart/stylesTheme';
import InternalLineChart, { selectionConfig, labelsSelectionConfig, legendsSelectionConfig } from '../internal/LineChart';
import { overrideConfig } from '../internal/LineChart/utils';
import { jsx as _jsx } from "react/jsx-runtime";

const LineChart = _ref => {
  let {
    reportingWidgetId,
    config: defaultConfig
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const config = overrideConfig(defaultConfig);
  const {
    lineThemeStyles,
    themeCtx
  } = useLineStyles(config);
  const {
    colorPallet: defaultColorPallet = DEFAULT_COLORS
  } = themeCtx;
  const {
    selections = '',
    labelsSelections = '',
    legendsSelections = '',
    selectionsLabeled = true,
    selectionsStrategy = 'default',
    globalSeriesOptions,
    seriesOptions = [],
    collectionOptions = [],
    colorPallet = defaultColorPallet,
    chartStyle
  } = config;
  const xAxisTemplate = config.xAxisTemplate || (globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.xAxisTemplate);
  const yAxisTemplate = config.yAxisTemplate || (globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.yAxisTemplate);
  const results = useSubscribeWidgetResults(reportingWidgetId);
  const isAreaChart = chartStyle && ['area', 'stackedArea'].includes(chartStyle); // Get relevant results for each selection

  const {
    selectionResults,
    resultsUpdated
  } = useSelections({
    results,
    selections,
    selectionsLabeled,
    selectionConfig
  }); // Get selection labels

  const {
    selectionLabels
  } = useSelectionLabels({
    results,
    resultsUpdated,
    labelsSelections,
    labelsSelectionConfig,
    labelsTemplate: (globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.labelsTemplate) || xAxisTemplate
  });
  const {
    selectionLegends
  } = useSelectionLegends({
    results,
    resultsUpdated,
    legendsSelections,
    legendsSelectionConfig
  });
  const {
    chartData
  } = useData({
    results: selectionResults,
    selectionLabels,
    selectionLegends,
    seriesOptions,
    globalSeriesOptions,
    collectionOptions,
    colorPallet,
    selectionsStrategy,
    legends: config.legends,
    xAxisTemplate,
    yAxisTemplate,
    areaChartDefaultFill: isAreaChart ? lineThemeStyles.areaChartDefaultFill : undefined,
    themeStyles: lineThemeStyles
  }); // Ignore the labels template
  // as it is handled by the selectionLabels

  const {
    xAxisTicksCallback,
    yAxisTicksCallback,
    openLegendsContextEditor
  } = useChartActions({
    yAxisTemplate: yAxisTemplate
  }); // Data & Loading States

  const hasNoData = !hasAnySelectionData(selectionResults);
  const isLoading = !results.length;
  return /*#__PURE__*/_jsx(InternalLineChart, _objectSpread(_objectSpread({}, props), {}, {
    reportingWidgetId: reportingWidgetId,
    config: config,
    hasNoData: hasNoData,
    isLoading: isLoading,
    chartData: chartData,
    xAxisTicksCallback: xAxisTicksCallback,
    yAxisTicksCallback: yAxisTicksCallback,
    openLegendsContextEditor: openLegendsContextEditor
  }));
};

export default LineChart;
export { DEFAULT_COLORS, useData, useSelections, selectionConfig, labelsSelectionConfig };